var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-index"},[_c('HomeLanding',{attrs:{"settings":_vm.settings,"landing-video":_vm.landingVideo}}),_vm._v(" "),_c('HomeSections',{attrs:{"sections":_vm.sections}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }